// Role configuration for the chatbot widget embedded in BGCM-UI.
// Mirrors the RBAC scopes enforced by the FastAPI backend (app/core/security.py).

export const ROLE_CONFIG = {
  ADMIN: {
    label: 'Admin',
    color: '#14213D',
    softBg: '#EBEDF2',
    accentText: '#14213D',
    description: 'Full system access — users, verification oversight, reports',
    examples: [
      'How do I inactivate an employee?',
      'How do I assign a candidate to an agent?',
      'How do I generate a verification report?',
    ],
  },
  USER: {
    label: 'Company / HR',
    color: '#3B5BA9',
    softBg: '#EAEEF8',
    accentText: '#3B5BA9',
    description: 'Add candidates, raise BGC requests, track status',
    examples: [
      'How do I add a new candidate for verification?',
      'How can I check a candidate\'s verification status?',
      'How do I download the final BGC report?',
    ],
  },
  EMPLOYEE: {
    label: 'Agent',
    color: '#0F8A65',
    softBg: '#E4F3EC',
    accentText: '#0F8A65',
    description: 'Conduct verification checks, submit findings',
    examples: [
      'What documents do I need for employment verification?',
      'What\'s the difference between virtual and physical address verification?',
      'How do I submit my findings for a candidate?',
    ],
  },
  CANDIDATE: {
    label: 'Candidate',
    color: '#14213D',
    softBg: '#EBEDF2',
    accentText: '#14213D',
    description: 'Complete your verification, check your status',
    examples: [
      'What documents do I need to submit?',
      'How do I verify my Aadhaar card?',
      'How do I check my verification status?',
    ],
  },
};

export const DEFAULT_ROLE_CONFIG = {
  label: 'Assistant',
  color: '#14213D',
  softBg: '#EBEDF2',
  accentText: '#14213D',
  description: 'Ask about documents, verification status, or the BGC process',
  examples: [
    'What is the BGC verification process?',
    'What documents are typically required?',
    'How long does verification usually take?',
  ],
};

export function getRoleConfig(role) {
  const norm = (role || '').toUpperCase();
  if (norm === 'ADMIN' ) return ROLE_CONFIG.ADMIN;
  if (norm === 'USER' ) return ROLE_CONFIG.USER;
  if (norm === 'EMPLOYEE' ) return ROLE_CONFIG.EMPLOYEE;
  if (norm === 'CANDIDATE' ) return ROLE_CONFIG.CANDIDATE;
  return DEFAULT_ROLE_CONFIG;
}

